// extracted by mini-css-extract-plugin
module.exports = {"redirectButton":"ProductEditBasicSection_redirectButton__1lC1c","disconnectButton":"ProductEditBasicSection_disconnectButton__2cHj2"};